export const base_url = "https://b-m-jewels-backend-1.onrender.com/api/";
// export const base_url = "http://localhost:7000/api/";
